import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
import authModule from "./authModule";
import cartModule from "./cartModule";

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    authModule,
    cartModule
  }
});
